@if ({}; as STATE) {
  <main #layout class="layout">
    <header class="layout-header-wrapper"></header>
    <div class="layout-content-wrapper">
      <content-wrapper>
        <router-outlet></router-outlet>
      </content-wrapper>
    </div>
  </main>
}
